<!-- begin::Quick Sidebar -->
<div id="m_quick_sidebar" class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light" appunwraptag="">
  <div class="m-quick-sidebar__content m--hide">
    <span id="m_quick_sidebar_close" class="m-quick-sidebar__close">
      <i class="la la-close"></i>
    </span>
    <ul id="m_quick_sidebar_tabs" class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand" role="tablist">
      <li class="nav-item m-tabs__item">
        <a class="nav-link m-tabs__link active" data-toggle="tab" href="#m_quick_sidebar_tabs_messenger" role="tab">
          Mesajlar
        </a>
      </li>
      <li class="nav-item m-tabs__item">
        <a class="nav-link m-tabs__link" data-toggle="tab" href="#m_quick_sidebar_tabs_settings" role="tab">
          Ayarlar
        </a>
      </li>

    </ul>
    <div class="tab-content">
      <div class="tab-pane active m-scrollable" id="m_quick_sidebar_tabs_messenger" role="tabpanel" *ngIf="_dashboardItemResponseModel !== null">
        <div class="m-messenger m-messenger--message-arrow m-messenger--skin-light">
          <div class="m-messenger__messages">
            <div class="m-messenger__wrapper">
              <div class="m-messenger__message m-messenger__message--in" *ngFor="let msg of _dashboardItemResponseModel.UserMessages">
                  <div class="m-messenger__message-pic">
                  <img src="./assets/app/media/img/users/user1.jpg" alt=""/>
                  </div>
                  <div class="m-messenger__message-body">
                  <div class="m-messenger__message-arrow"></div>
                  <div class="m-messenger__message-content" >
                  <div class="m-messenger__message-username">
                  Yönetici
                  </div>
                  <div class="m-messenger__message-text">
                    {{msg.Message}} [{{msg.CreateDate  | date: 'dd.MM.yyyy hh:mm'}}]
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="m-messenger__seperator"></div>
        </div>
      </div>
      <div class="tab-pane  m-scrollable" id="m_quick_sidebar_tabs_settings" role="tabpanel" *ngIf="_dashboardItemResponseModel !== null">
        <div class="m-list-settings">
          <div class="m-list-settings__group">
            <div class="m-list-settings__heading">
              Genel Ayarlar
            </div>

            <div class="m-list-settings__item" *ngFor="let itm of _dashboardItemResponseModel.Settings">
              <span class="m-list-settings__item-label">
                {{itm.Name}}
              </span>
              <span class="m-list-settings__item-control">
                <span class="m-switch m-switch--outline m-switch--icon-check m-switch--brand">
                  <label>
                    <input type="checkbox" name="{{itm.Id}}" [checked]="itm.DefaultValue">
                    <span></span>
                  </label>
                </span>
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- end::Quick Sidebar -->
